import React, { useRef, useState } from 'react';
import './SearchField.css';
import SearchIcon from './SearchIcon';

const SearchField = ({
  input,
  onInputChange,
  onSendClick,
  suggestions = [],
  suggestionsLoading = false,
  onSuggestionSelect,
}) => {
  const suggestionText = "Such was...";

  const [localError, setLocalError] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);

  const chunksRef = useRef([]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      setShowSuggestions(false);
      onSendClick();
    }
  };

  const shouldShowSuggestions =
    showSuggestions && (suggestionsLoading || suggestions.length > 0);

  const combinedError = localError;

  return (
    <div className="search-container">
      <div className="search-field-inner">
        <input
          type="text"
          value={input}
          onChange={(e) => onInputChange(e.target.value)}
          onFocus={() => setShowSuggestions(true)}
          onBlur={() => {
            setTimeout(() => setShowSuggestions(false), 150);
          }}
          placeholder={suggestionText}
          aria-label="Search"
          className="search-input"
          onKeyDown={handleKeyDown}
          autoComplete="off"
        />

        <div className="icon-container">
          <button
            className="search-button"
            onClick={onSendClick}
            aria-label="Search"
            type="button"
          >
            <SearchIcon size="40" />
          </button>
        </div>
      </div>

      {shouldShowSuggestions && (
        <div className="search-suggestions" role="listbox" aria-label="Suchvorschlaege">
          {suggestionsLoading && suggestions.length === 0 ? (
            <div className="search-suggestion-loading">Lade Vorschlaege...</div>
          ) : (
            suggestions.map((suggestion) => (
              <button
                key={suggestion}
                type="button"
                className="search-suggestion-item"
                onMouseDown={() => {
                  setShowSuggestions(false);
                  onSuggestionSelect?.(suggestion);
                }}
              >
                {suggestion}
              </button>
            ))
          )}
        </div>
      )}

      {combinedError && (
        <div className="search-error">{combinedError}</div>
      )}
    </div>
  );
};

export default SearchField;
